// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__zPOJO","active":"NavigationItem_active__24GzZ"};